export enum ContactDeactivationStep {
  Welcome,
  ReassignRoles,
  ReassignFlags,
  Backup,
  Completion,
}

export const HP_ROLE_TO_REASSIGN = [
  'HP Champion',
  'Partner Signer',
  'L&R Champion',
  'General Manager',
]

export const HP_FLAG_TO_REASSIGN = ['PFP Admin(PPA)']

export enum ContactDeactivationError {
  FetchContacts = 'Failed to fetch contacts',
  DeactivateContact = 'Failed to deactivate contact.',
  ReassignRoles = 'Failed to reassign roles.',
  ReassignFlags = 'Failed to reassign flags.',
  // Add more error messages as needed
}
